import { render, staticRenderFns } from "./WelcomeInfinite.vue?vue&type=template&id=15de926e"
import script from "./WelcomeInfinite.vue?vue&type=script&lang=js"
export * from "./WelcomeInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports